import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Shown once to every new member: Rich's 24-second welcome, storm → sunrise.
export const WelcomeVideoDialog = ({ open, onClose, firstName }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = false;
    v.play().then(() => setPlaying(true)).catch(() => {});
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-[#FAF7F2] border-[#F59E0B]/40 text-[#1C1917] max-w-3xl p-0 overflow-hidden" data-testid="welcome-video-dialog">
        <div className="relative aspect-video bg-black">
          <video
            ref={ref}
            src="/videos/rich_talking.mp4"
            poster="/videos/rich_talking.jpg"
            preload="metadata"
            playsInline
            controls={playing}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            onEnded={() => setTimeout(onClose, 900)}
            className="absolute inset-0 w-full h-full object-contain"
            data-testid="welcome-video"
          />
          {!playing && (
            <button
              onClick={start}
              data-testid="welcome-video-play"
              aria-label="Play Rich's welcome"
              className="absolute inset-0 flex items-center justify-center bg-black/35 hover:bg-black/25 transition-colors"
            >
              <span className="w-20 h-20 rounded-full bg-[#F59E0B] text-black flex items-center justify-center shadow-[0_0_60px_rgba(245,158,11,0.45)]">
                <Play size={28} fill="currentColor" className="ml-1" />
              </span>
            </button>
          )}
        </div>
        <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <DialogTitle className="font-display text-2xl md:text-3xl tracking-tight leading-tight">
              Welcome, {firstName}. A word from Rich — in his own voice.
            </DialogTitle>
            <DialogDescription className="text-[#78716C] text-sm mt-1">Press play, then we&apos;ll show you around.</DialogDescription>
          </div>
          <button onClick={onClose} data-testid="welcome-video-skip" className="btn-outline text-xs shrink-0 w-fit">
            {playing ? "Continue to dashboard" : "Skip for now"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
